// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"header-content_wrapper_372"};